import React from 'react';
import FormationCarousel from './FormationCarousel';
import FormationPlusCarousel from './FormationPlusCarousel';
import HoverReveal from './HoverReveal';
import Presantation from './Presantation';
import ReferencesCarousel from './ReferencesCarousel';
import Scrollefec from './Scrollefec';

const Home = () => {
	return (
		<>
			<Presantation />
			<HoverReveal />
			<FormationCarousel />
			<FormationPlusCarousel />
			<ReferencesCarousel />
			<Scrollefec />
		</>
	);
};

export default Home;
